const Styles = {
  modalCityGroup: {
    width: '495px',
  },
  gridStyle: {
    marginTop: '30px',
  },
};
export default Styles;
